
export const snakeToTitleCase = value => {
    if (!value) return '';
    return value.split('_').map(function(item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
    }).join(' ');
}
